<template>
  <section class="hero">
    <div class="hero-body has-text-centered fondu" :class="{'fonduenter': loadLogo}">
      <img width="40%" :src="loadLogo" class="fondu" :class="{'fonduenter': loadLogo}"/>
      <br />
      <br />
      <h2 class="subtitle">
        Administration
      </h2>
    </div>
  </section>
</template>

<script>
import { mediaRef } from '@/admin/firebase_config'
import imageLoader from '@/admin/mixins/image-loader'
export default {
  name: 'home',
  data () {
    return {
      websiteLogo: ''
    }
  },
  firebase: {
    media: mediaRef
  },
  mixins: [imageLoader],
  computed: {
    loadLogo () {
      var i = this.media.length
      var url = null
      while (i--) {
        if (this.media[i].name === 'WebsiteLogo') {
          url = this.media[i].src
        }
      }
      return url
    }
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/admin/components/layout/Home.vue